<div class="app-spinner" role="alert" aria-live="assertive">
  <i class="pbi-icon-mini pbi-loader-circle spin" [class]="iconClass" aria-hidden="true"></i>
  <p class="sr-only">Loading...</p>
</div>
